import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Generic interface — works for both Advisor and Learning Specialist
interface RoleMember {
    teacher_id: string;
    teacher_name: string;
    teacher_email: string;
    ai_avatar: string | null;
    created_at: string;
    status: string;
    school_id: string;
    // student fields
    student_id?: string;
    student_name?: string;
    grade?: string;
    ai_student_profile_pic?: string | null;
    students_join_date?: string;
    student_enroll_count?: number;
}

interface AccessControlRoleState {
    roleList: RoleMember[];
    next: string | null;
    previous: string | null;
    count: number | null;
    totalPages: number | null;
    isLoading: boolean;
    error: string | null;
}

const initialState: AccessControlRoleState = {
    roleList: [],
    next: null,
    previous: null,
    count: 0,
    totalPages: 0,
    isLoading: false,
    error: null,
};

const getAccessControlRoleSlice = createSlice({
    name: "getAccessControlRoleSlice",
    initialState,
    reducers: {
        setAccessControlRoleList: (
            state: AccessControlRoleState,
            action: PayloadAction<RoleMember[]>
        ) => {
            state.roleList = action.payload;
            state.isLoading = false;
            state.error = null;
        },
        setPagination: (
            state: AccessControlRoleState,
            action: PayloadAction<AccessControlRoleState>
        ) => {
            state.next = action.payload.next;
            state.previous = action.payload.previous;
            state.count = action.payload.count;
            state.totalPages = Math.ceil((action.payload.count ?? 0) / 12);
            state.isLoading = false;
            state.error = null;
        },
        setLoading: (
            state: AccessControlRoleState,
            action: PayloadAction<boolean>
        ) => {
            state.isLoading = action.payload;
            state.error = null;
        },
        setError: (
            state: AccessControlRoleState,
            action: PayloadAction<string>
        ) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        resetAccessControlRoleList: () => {
            return initialState;
        },
    },
});

export const {
    setAccessControlRoleList,
    setLoading,
    setError,
    setPagination,
    resetAccessControlRoleList,
} = getAccessControlRoleSlice.actions;

export default getAccessControlRoleSlice.reducer;